var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TerminalReadOnly',{attrs:{"breakOnNewLine":"","readOnlyText":_vm.welcomeText}})
}
var staticRenderFns = []

export { render, staticRenderFns }